import { useEffect } from "react";
import { siteConfig } from "./site.config";

declare global {
  interface Window {
    dataLayer?: unknown[];
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

function appendInlineScript(code: string) {
  const s = document.createElement("script");
  s.textContent = code;
  document.head.appendChild(s);
}

/**
 * Injects third-party pixels when env IDs are set. Extend site.config + this file for new vendors.
 */
export function PixelScripts() {
  const { gtmContainerId, metaPixelId, googleAdsId, linkedInPartnerId } = siteConfig.analytics;

  useEffect(() => {
    if (gtmContainerId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtm.js?id=${gtmContainerId}`;
      document.head.appendChild(s);
    }

    if (metaPixelId) {
      appendInlineScript(`
        !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
        document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${metaPixelId}');
        fbq('track', 'PageView');
      `);
    }

    if (googleAdsId) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`;
      document.head.appendChild(s);
      appendInlineScript(`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${googleAdsId}');
      `);
    }

    if (linkedInPartnerId) {
      appendInlineScript(`
        _linkedin_partner_id = "${linkedInPartnerId}";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      `);
      const l = document.createElement("script");
      l.async = true;
      l.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      document.head.appendChild(l);
    }
  }, [gtmContainerId, metaPixelId, googleAdsId, linkedInPartnerId]);

  if (!gtmContainerId) return null;

  return (
    <noscript>
      <iframe
        title="Google Tag Manager"
        src={`https://www.googletagmanager.com/ns.html?id=${gtmContainerId}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  );
}
